import { apiClient } from './apiClient';

export interface ResearchReport {
  id: number;
  symbol: string;
  title: string;
  content: string;
  timestamp: string;
  template?: {
    feishu?: {
      title?: string;
      content?: {
        text?: string;
      };
    };
  };
}

export interface ResearchReportListResponse {
  alerts: ResearchReport[];
  total: number;
}

export class ResearchReportService {
  /**
   * Get research reports
   */
  async getResearchReports(limit: number = 50, offset: number = 0, symbol?: string): Promise<ResearchReportListResponse> {
    try {
      const response = await apiClient.get<ResearchReportListResponse>('/research-reports', {
        params: { limit, offset, symbol },
      });

      if (!response.success) {
        throw new Error(response.message || 'Failed to fetch research reports');
      }

      return response.data;
    } catch (error: any) {
      console.error('Get research reports error:', error);
      throw error;
    }
  }

  /**
   * Get research report by ID
   */
  async getResearchReportById(id: number): Promise<ResearchReport> {
    try {
      const response = await apiClient.get<ResearchReport>(`/research-reports/${id}`);

      if (!response.success) {
        throw new Error(response.message || 'Failed to fetch research report');
      }

      return response.data;
    } catch (error: any) {
      console.error('Get research report error:', error);
      throw error;
    }
  }

  /**
   * Get research report by symbol
   */
  async getResearchReportBySymbol(symbol: string): Promise<ResearchReport | null> {
    try {
      const response = await this.getResearchReports(1, 0, symbol);
      return response.alerts.length > 0 ? response.alerts[0] : null;
    } catch (error) {
      return null;
    }
  }
}

export const researchReportService = new ResearchReportService();
